import { useEffect } from 'react';
import { AwsRum } from 'aws-rum-web';
import { clientConfig } from '../config/clientConfig';
import { buildRumConfig } from './rum-config';
import { applyRumJourney } from '../utils/rumJourney';

export default function AwsRumScript() {
  useEffect(() => {
    try {
      if (!window.AwsRum && clientConfig.awsRum.enabled) {
        const awsRum: AwsRum = new AwsRum(
          clientConfig.awsRum.applicationId,
          '1.0.0',
          clientConfig.awsRum.region,
          buildRumConfig({
            identityPoolId: clientConfig.awsRum.identityPoolId,
            region: clientConfig.awsRum.region,
          })
        );

        window.AwsRum = awsRum;
        applyRumJourney(awsRum);
      }
    } catch (error) {
      console.debug('Failed to initialize AWS RUM:', error);
    }
  }, []);

  return null;
}